import { css } from "lit";

export const notificationItemStyles = css`
  :host {
    display: block;
    transition:
      opacity 0.3s ease-out,
      transform 0.3s ease-out;
    opacity: 1;
    pointer-events: auto;
  }

  /* Desktop: slide in from right */
  @media (min-width: 768px) {
    :host {
      transform: translateX(0);
    }

    :host(.entering) {
      opacity: 0;
      transform: translateX(100%);
    }

    :host(.removing) {
      opacity: 0;
      transform: translateX(100%);
      pointer-events: none;
    }
  }

  /* Mobile: slide in from top */
  @media (max-width: 767px) {
    :host {
      transform: translateY(0);
    }

    :host(.entering) {
      opacity: 0;
      transform: translateY(-100%);
    }

    :host(.removing) {
      opacity: 0;
      transform: translateY(-100%);
      pointer-events: none;
    }
  }

  .notification-wrapper {
    cursor: pointer;
    transition:
      opacity 0.3s ease-out,
      transform 0.3s ease-out;
    opacity: 1;
  }

  /* Desktop: slide in from right */
  @media (min-width: 768px) {
    .notification-wrapper {
      transform: translateX(0);
    }

    .notification-entering {
      opacity: 0;
      transform: translateX(100%);
    }
  }

  /* Mobile: slide in from top */
  @media (max-width: 767px) {
    .notification-wrapper {
      transform: translateY(0);
    }

    .notification-entering {
      opacity: 0;
      transform: translateY(-100%);
    }
  }

  .notification-wrapper:hover {
    opacity: 0.8;
  }

  .notification-wrapper:active {
    transform: scale(0.98);
  }

  /* Mobile responsive adjustments */
  @media (max-width: 767px) {
    .notification-wrapper:active {
      transform: translateY(0) scale(0.98);
    }

    .notification-removing:active {
      transform: translateY(-100%) scale(0.98);
    }
  }

  /* Desktop responsive adjustments */
  @media (min-width: 768px) {
    .notification-wrapper:active {
      transform: translateX(0) scale(0.98);
    }

    .notification-removing:active {
      transform: translateX(100%) scale(0.98);
    }
  }
`;
